import {ResponseStatus} from "../../actions/types";
import {jwtDecode} from "jwt-decode";

export function handleLogin(state: LoginState, status: ResponseStatus, payload: any): void {
    switch (status) {
        case ResponseStatus.PENDING:
            state.isLoading = true;
            state.errorMessage = '';
            state.isLoggedIn = false;

            break;
        case ResponseStatus.FAIL:
            localStorage.clear();

            state.isLoading = false;

            const responseData = payload?.response?.data;

            if (responseData) {
                if (Array.isArray(responseData)) {
                    state.errorMessage = responseData.length ? responseData[0].message : '';
                } else {
                    state.errorMessage = payload?.response?.data?.message;
                }
            }
            state.isLoggedIn = false;

            break;
        case ResponseStatus.SUCCESS:
            state.isLoading = false;
            localStorage.setItem('access_token', payload.accessToken);
            localStorage.setItem('refresh_token', payload.refreshToken);
            const decodedToken = jwtDecode<TokenDataModel>(payload.accessToken);
            state.userGroup = decodedToken ? decodedToken.userGroup : null;
            state.isLoggedIn = true;

            break;
    }
}

export function handleLogOut(state: LoginState): void {
    state.isLoggedIn = false;
    state.userGroup = null;
    localStorage.clear();
}

export interface LoginState {
    isLoading: boolean,
    errorMessage: string,
    isLoggedIn: boolean,
    userGroup: number | null
}

export interface TokenDataModel {
    fullName: string,
    userId: number,
    userGroup: number,
    _id: string
}
